import {
    post,
    put,
    endpoints,
    postGQL,
    upload,
    deleteCall,
} from '../../api';
import { getReferer } from '../../api/factory';

import {
   searchQuery,
} from './queries';

export function apiAuthGetPublisherInfo (data, { traceId }) {
    return post(
        endpoints().authGetPublisherInfo,
        data,
        {
            traceId,
        }
    );
}

export function apiSearch ({ name, email, publisherIds, token, traceId, page = 1 }) {
    const qInput = {
        filterInput: {
            name,
            email,
            publisherIds,
        },

        pageInput: {
            pageNumber: page,
            pageLength: 10,
        },
    };

    /*
    if (!name) {
        qInput.input = {};
    }
    */

    return postGQL(
        endpoints().searchPublishers,
        searchQuery({ ...qInput }),
        {
            token,
            traceId,
            action: 'searchPublishers',
        }
    );
}

export function apiUpdateProfile ({ user, token, traceId }) {
    return put(
        endpoints().updateProfile,
        user,
        {
            token,
            traceId,
            action: 'updateProfile',
        }
    );
}

export function apiUploadPublisherAssets ({ data, token, traceId }) {
   return upload(
        endpoints().uploadPublisherAssets,
        data,
        {
            token,
            traceId,
        }
    );
}

/*
 * TEMPORARY: reuses the upload-assets endpoint's base URL with the final path
 * segment swapped to upload-cover-photos, instead of a dedicated endpoint entry.
 * The backend serves the identical handler on both paths — upload-cover-photos
 * only adds an email-allowlist check, so bypassing it (superadmin dev access)
 * just means hitting the regular upload-assets path with the same payload/token.
 */
function getUploadAssetsEndpoint (bypassRestriction) {
    if (bypassRestriction) {
        return endpoints().uploadPublisherAssets;
    }
    return endpoints().uploadPublisherAssets.replace('upload-assets', 'upload-cover-photos');
}

export function apiUploadPublisherAssetsRestricted ({ data, token, traceId, bypassRestriction = false }) {
   return upload(
        getUploadAssetsEndpoint(bypassRestriction),
        data,
        {
            token,
            traceId,
        }
    );
}

export function apiGenerateSVG ({ data, token, traceId }) {
    return post(
         endpoints().publisherGenerateSVG,
         data,
         {
             token,
             traceId,
         }
     );
}

export function apiPublisherLogo ({ data, token, traceId }) {
    return post(
         endpoints().publisherLogo,
         data,
         {
             token,
             traceId,
             returnOnError: true,
             action: 'getPublisherLogo',
         }
     );
}

export function apiDeletePublisherLogo ({ token, traceId }) {
    return deleteCall(
         endpoints().publisherLogo,
         {
             token,
             traceId,
         }
     );
}

export function apiInsertLead ({ data, token, traceId }) {
    return post(
        `${endpoints().adminCRM}/insertLead`,
        data,
        {
            token,
            traceId,
            headers: {
                'referrer': getReferer(),
            },
            returnOnError: true,
            action: 'insertLead',
        }
    );
}
